/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { getAiService } from '../GetAiService/getAiService';
import { useMemo } from 'react';
import { from } from 'rxjs';
import { ExtendedJsonSchema } from '@squiz/dxp-ai-client';
import { useObservable, UseObservableResult } from '@squiz/dxp-console-support';

export const useContextSchema = (aiId: string, contextId: string): UseObservableResult<ExtendedJsonSchema | null> => {
  const aiService = getAiService();
  const contexts$ = useMemo(() => {
    return from(aiService.apiClient.chatbotContext.getSchema(aiId, contextId));
  }, [aiId, aiService, contextId]);

  return useObservable(contexts$, [contexts$]);
};
